// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3L2Fy","footer":"ModalError_footer__17_uH"};